module.exports = __webpack_public_path__ + "assets/img/f831-kn.svg";